import { useBillingPlans } from "@features/bx/BulkBillGeneration/hooks";
import { useCurrency } from "@shared/selectors/globalSelectors";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Eye } from "lucide-react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PlanDetailsModal from "../PlanDetailsModal";

export const PlansSubTab = () => {
  const { id, cycleId } = useParams();
  const currency = useCurrency();
  const { data: plansList } = useBillingPlans(cycleId);
  const [openModal, setOpenModal] = useState(false);
  
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium text-gray-700">
        Available Plans
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {plansList?.map((plan) => (
          <div
            key={plan.id}
            className="bg-white rounded-lg border shadow-sm p-5 hover:shadow-md transition-shadow"
          >
            {/* Header */}
            <div className="flex items-start justify-between mb-4">
              <h4 className="text-lg font-semibold">{plan?.planName}</h4>
              <Badge
                variant={
                  plan?.status?.toLowerCase() === "active"
                    ? "default"
                    : "secondary"
                }
                className={
                  plan?.status?.toLowerCase() === "active"
                    ? "bg-green-100 text-green-700"
                    : "bg-yellow-100 text-yellow-700"
                }
              >
                {plan?.status}
              </Badge>
            </div>

            {/* Details */}
            <div className="space-y-2 mb-4">
              <div>
                <p className="text-xs text-gray-600 mb-1">Category:</p>
                <div className="flex flex-wrap gap-1">
                  {Array.isArray(plan.category) ? (
                    plan.category.length > 0 ? (
                      plan.category.map((cat: string, i: number) => (
                        <Badge key={i} variant="outline" className="font-medium">
                          {cat}
                        </Badge>
                      ))
                    ) : (
                      <span className="text-sm font-medium">NA</span>
                    )
                  ) : plan.category ? (
                    <Badge variant="outline" className="font-medium">
                      {plan.category}
                    </Badge>
                  ) : (
                    <span className="text-sm font-medium">NA</span>
                  )}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-600">Validity:</p>
                <p className="text-sm font-medium">
                 {plan.endDate ?? "Ongoing"}
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-200 my-4" />

            {/* Metrics */}
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Total Consumers</span>
                <span className="text-lg font-bold">
                  {plan.totalConsumers ?? "NA"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Estimated Billed</span>
                <span className="text-lg font-bold text-green-600">
                  {currency} {plan.estimatedBillingValue ?? "NA"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Avg Bill</span>
                <span className="text-lg font-bold text-blue-600">
                  {currency} {plan.avgBill ?? "NA"}
                </span>
              </div>
            </div>

            {/* View Details Button */}
            <Button
              variant="outline"
              className="w-full mt-4"
              size="sm"
              onClick={() => {
                window.open(`/plan-tarrif/plan/view/${plan.id}`, '_blank');
              }}
            >
              <Eye className="w-4 h-4 mr-2" />
              View Details
            </Button>
          </div>
        ))}
      </div>
      {/* {openModal && (
        <PlanDetailsModal
          id={selectedPlanId}
          open={openModal}
          onClose={() => setOpenModal(false)}
        />
      )} */}
    </div>
  );
};
